import { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

import { usePymbleApi } from "./usePymbleApi";

// const API_END_POINT = `${api.dtAdmin}/teacher-lessons`;
const API_END_POINT = "/teacher/admin/classes/";

/**
 * Hook for separate loading of classes (for teachers)
 * for components
 */
export function useTeacherClasses(
  searchDate: string | null = null,
  teacherId: string | null = null,
) {
  const [teacherClasses, setTeacherClasses] = useState<any>([]);
  const [teacherClassesLoaded, setTeacherClassesLoaded] = useState(false);

  const queryClient = useQueryClient();

  const { callApiS2: callApi, isAuthenticated } = usePymbleApi();

  // Load the data from api
  let queryKey = ["teacher-classes", searchDate, teacherId];

  const { isLoading, isError, data, error } = useQuery({
    queryKey,
    queryFn: async () => {
      const url =
        API_END_POINT + teacherId + "?date=" + searchDate;
      const res = await callApi("GET", url);
      return res;
    },
    enabled: isAuthenticated && Boolean(teacherId),
  });

  // When the data is loaded, set the state
  useEffect(() => {
    if (data) {
      let classdata = preProcessClasses(data?.classes);

      // Sort by date
      classdata = sortClasses(classdata);

      if (classdata) {
        setTeacherClasses(classdata);
      }
      setTeacherClassesLoaded(true);
    }
  }, [data]);

  const refreshTeacherClasses = async () => {
    queryClient.invalidateQueries({ queryKey });
  };

  // Only sort by start time at the moment
  const sortClasses = (data: any[]) => {
    return data.sort(function (a: any, b: any) {
      try {
        if (a && a.StartTime && b && b.StartTime) {
          var startA = a.StartTime;
          var startB = b.StartTime;
          if (startA < startB) {
            return -1;
          }
          if (startA > startB) {
            return 1;
          }
        }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        /* squash */
      }
      // names must be equal or documents incorrect
      return 0;
    });
  };

  // Decorate as required
  const preProcessClasses = (lesData: any) => {
    return lesData.map((a: any) => {
      // Add any required processing here
      return a;
    });
  };

  return {
    isError,
    isLoading,
    error,
    teacherClasses,
    refreshTeacherClasses,
    teacherClassesLoaded,
  };
}
